<template lang="pug">
div
  a.btn.btn-link(@click="$router.back()")
    i.fa.fa-arrow-left
    |
    | Voltar
  .divider
  load-manager(:status="status")
    div(v-if="current")
      show-mensagem(:mensagem="current")
      recursive-messages(:mensagem="current")
      .divider
      div(v-if="!respondendo")
        a.btn.btn-link(
          v-if="current.permite_responder && !current.arquivada_destinatario",
          @click="respondendo = true"
        )
          i.fa.fa-reply
          |
          | Responder
        a.btn.btn-link.text-error(
          v-if="!current.arquivada_destinatario",
          @click="arquivar"
        )
          i.fa.fa-archive
          |
          | Arquivar
        a.btn.btn-link(v-else, @click="restaurar")
          i.fa.fa-refresh
          |
          | Restaurar
      form(
        v-else-if="!current.arquivada_destinatario",
        @submit.prevent="responder"
      )
        .pb-1
          .text-large.text-bold Enviar resposta
          div Escreva uma resposta no campo abaixo e em seguida clique em "Enviar"
        textarea.form-input(
          v-autofocus,
          type="text",
          v-model="$v.resposta.conteudo.$model",
          :placeholder="'mensagem.conteudo' | tModel"
        )
        .text-right.pt-2
          a.btn.btn-link(@click="cancelarResposta") Cancelar
          button.btn.btn-primary(
            :disabled="$v.$invalid || respostaLoading",
            :class="{ loading: respostaLoading }"
          )
            i.fa.fa-paper-plane
            |
            | Enviar
</template>

<script>
import ShowMensagem from '../components/ShowMensagem.vue'
import RecursiveMessages from '../components/RecursiveMessages.vue'
import { required } from 'vuelidate/lib/validators'
import parseErrors from '@/lib/errors/parseErrors'
import api from '@/api/mensagens/recebidas'

export default {
  vuex: {
    'mensagens/recebidas': {
      state: ['current', 'status', 'respostaLoading'],
      actions: [
        'fetchOne',
        'fetchCount',
        'fetchResponder',
        'fetchArquivar',
        'fetchRestaurar',
        'fetchCount',
      ],
      getters: ['loading'],
    },
  },
  components: { ShowMensagem, RecursiveMessages },
  data() {
    return {
      respondendo: false,
      resposta: { conteudo: '' },
    }
  },
  validations: {
    resposta: {
      conteudo: { required },
    },
  },
  methods: {
    async getMensagem() {
      await this.fetchOne(this.$route.params.id)
      if (this.current.permite_ler) {
        await api.ler(this.current.id)
        this.fetchCount()
      }
    },

    async responder() {
      try {
        await this.fetchResponder({
          id: this.current.id,
          resposta: this.resposta,
        })
        await this.fetchOne(this.$route.params.id)
        this.cancelarResposta()
        this.$toaster.success('Mensagem respondida')
      } catch (e) {
        this.$toaster.error(parseErrors(e).join(', '))
      }
    },

    async arquivar() {
      const { ok } = await this.$dialogs.confirm(
        'Deseja arquivar a mensagem?',
        {
          title: 'Arquivar mensagem',
          cancelLabel: 'Não',
          okLabel: 'Sim',
          size: 'sm',
        },
      )

      if (ok) {
        try {
          await this.fetchArquivar(this.current.id)
          this.$toaster.success('Mensagem arquivada')
          this.$router.back()
        } catch (e) {
          this.$toaster.error(parseErrors(e).join(', '))
        }
      }
    },

    async restaurar() {
      const { ok } = await this.$dialogs.confirm(
        'Deseja restaurar a mensagem?',
        {
          title: 'Restaurar mensagem',
          cancelLabel: 'Não',
          okLabel: 'Sim',
          size: 'sm',
        },
      )

      if (ok) {
        try {
          await this.fetchRestaurar(this.current.id)
          this.$toaster.success('Mensagem restaurada')
          this.$router.back()
        } catch (e) {
          this.$toaster.error(parseErrors(e).join(', '))
        }
      }
    },

    cancelarResposta() {
      this.resposta = { conteudo: '' }
      this.respondendo = false
    },
  },
  created() {
    this.getMensagem()
  },
}
</script>
